export default __webpack_public_path__ + "static/media/2.f30dccc8.jpg";